// Generated by purs version 0.13.8
"use strict";
var Control_Bind = require("../Control.Bind/index.js");
var DOM_HTML_Indexed_InputType = require("../DOM.HTML.Indexed.InputType/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Number = require("../Data.Number/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Lunarbox_Component_Switch = require("../Lunarbox.Component.Switch/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var Lunarbox_Data_Dataflow_Native_Literal = require("../Lunarbox.Data.Dataflow.Native.Literal/index.js");
var Lunarbox_Data_Dataflow_Runtime = require("../Lunarbox.Data.Dataflow.Runtime/index.js");
var Lunarbox_Data_Dataflow_Runtime_Class_Runnable = require("../Lunarbox.Data.Dataflow.Runtime.Class.Runnable/index.js");
var Lunarbox_Data_Editor_FunctionName = require("../Lunarbox.Data.Editor.FunctionName/index.js");
var extendNativeConfig = function (v) {
    return Data_Tuple.Tuple.create(v.name);
};
var numberNodeInput = (function () {
    var render = function (v) {
        return Halogen_HTML_Elements.input([ Halogen_HTML_Properties.value((function () {
            if (v.value instanceof Lunarbox_Data_Dataflow_Runtime["Number"]) {
                return Data_Show.show(Data_Show.showNumber)(v.value.value0);
            };
            return Data_Maybe.fromMaybe("")(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.fromRuntime(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.corunnableString)(v.value));
        })()), Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType)(DOM_HTML_Indexed_InputType.InputNumber.value), Lunarbox_Component_Utils.className("node-input node-input--number"), Halogen_HTML_Events.onValueInput(function ($23) {
            return v.setValue(Lunarbox_Data_Dataflow_Runtime["String"].create($23));
        }) ]);
    };
    return extendNativeConfig(Lunarbox_Data_Dataflow_Native_Literal.number)({
        render: render,
        finalize: Control_Bind.composeKleisliFlipped(Data_Maybe.bindMaybe)((function () {
            var $24 = Data_Functor.map(Data_Maybe.functorMaybe)(Lunarbox_Data_Dataflow_Runtime["Number"].create);
            return function ($25) {
                return $24(Data_Number.fromString($25));
            };
        })())(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.fromRuntime(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.corunnableString))
    });
})();
var stringNodeInput = (function () {
    var render = function (v) {
        return Halogen_HTML_Elements.input([ Halogen_HTML_Properties.value(Data_Maybe.fromMaybe("")(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.fromRuntime(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.corunnableString)(v.value))), Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType)(DOM_HTML_Indexed_InputType.InputText.value), Lunarbox_Component_Utils.className("node-input node-input--string"), Halogen_HTML_Events.onValueInput(function ($26) {
            return v.setValue(Lunarbox_Data_Dataflow_Runtime["String"].create($26));
        }) ]);
    };
    return extendNativeConfig(Lunarbox_Data_Dataflow_Native_Literal.string)({
        render: render,
        finalize: Data_Maybe.Just.create
    });
})();
var booleanNodeInput = (function () {
    var render = function (v) {
        return Lunarbox_Component_Switch["switch"]({
            checked: Data_Maybe.fromMaybe(false)(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.fromRuntime(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.corunnableBool)(v.value)),
            round: true
        })(function ($27) {
            return v.setValue(Lunarbox_Data_Dataflow_Runtime.Bool.create($27));
        });
    };
    return extendNativeConfig(Lunarbox_Data_Dataflow_Native_Literal["boolean"])({
        render: render,
        finalize: Data_Maybe.Just.create
    });
})();
var nodeUis = Data_Map_Internal.fromFoldable(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(Data_Foldable.foldableArray)([ stringNodeInput, numberNodeInput, booleanNodeInput ]);
var hasUi = Data_Function.flip(Data_Map_Internal.member(Lunarbox_Data_Editor_FunctionName.ordFunctionName))(nodeUis);
var runNodeUi = function (inputs) {
    return function (name) {
        return Lunarbox_Component_Utils.maybeElement(Data_Map_Internal.lookup(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(name)(nodeUis))(function (v) {
            return v.render(inputs);
        });
    };
};
var uiToRuntime = function (name) {
    return function (value) {
        return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Map_Internal.lookup(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(name)(nodeUis))(function (v) {
            return v.finalize(value);
        });
    };
};
module.exports = {
    runNodeUi: runNodeUi,
    uiToRuntime: uiToRuntime,
    hasUi: hasUi
};
